/* eslint-disable no-empty-function */
import { transformDOMQLEmotion, createEmotion } from 'smbls'

export const createClientContext = (el) => {
  const frameDocument = el.node.contentDocument
  if (!frameDocument) {
    return
  }

  const emotion = createEmotion('demo', frameDocument.head)
  const registry = transformDOMQLEmotion(emotion)
  registry.emotion = emotion

  const state = { ...el.getData('state') }
  const designSystem = { ...el.getData('designSystem') }
  const components = { ...el.getData('components') }
  const files = { ...el.getData('files') }
  const dependencies = { ...el.getData('dependencies') }
  const functions = { ...el.getData('functions'), router: () => {} }
  const snippets = { ...el.getData('snippets'), router: () => {} }
  const methods = { ...el.getData('methods'), router: () => {} }

  return {
    key: 'demo',
    parent: frameDocument,
    state,
    designSystem,
    components,
    snippets,
    functions,
    registry,
    methods,
    files,
    dependencies,
    initOptions: { emotion, useReset: true, useGlobalTheme: false }
  }
}
